import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Api from '../utils/Api';
import { useError } from '../context/ErrorContext';
import { useLoading } from '../context/LoadingContext';

const CountryContext = createContext();

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
};

export const CountryProvider = ({ children }) => {
  const {  hideLoading } = useLoading();
  const { getToken } = useAuth();
  const [api, setApi] = useState(null);
  const { handleApiError, formErrors, clearErrors } = useError();
  const [countries, setCountries] = useState([]);
  const [isApiReady, setIsApiReady] = useState(false);

  // Initialize API with token getter
  useEffect(() => {
    
    const initializeApi = async () => {
      try {
        const apiInstance = Api(() => getToken());
        setApi(apiInstance);
        setIsApiReady(true);
      } catch (error) {
        console.error('Error initializing API:', error);
      }
    };
    
    initializeApi();
  }, [getToken]);

  const getCountries = async () => {
    if (!isApiReady || !api) {
      
      return;
    }

    try {
      clearErrors();
      const response = await api.call('countries', 'GET', null, false);
       if (response?.status === 200) {
        hideLoading();
        setCountries(response?.data.countries);
        return { status: response.status };
      } else {
        hideLoading();
        if (response?.error?.status === 422) {
          return {
            status: response?.error?.status,
            errors: response?.error?.validationErrors
          };
        } else {
          
          return handleApiError(response.error, {
            showAlert: false,
            redirectOn401: true,
            customMessage: 'Failed to fetch countries'
          });
        }
      }
      } catch (error) {
        console.error('Error fetching countries:', error);
        return handleApiError(error, {
          showAlert: false,
          redirectOn401: true,
          customMessage: 'Failed to fetch countries'
        });
      }
  };

  return (
    <CountryContext.Provider
      value={{
        countries,
        getCountries,
        formErrors,
        clearErrors,
        isApiReady
      }}
    >
      {children}
    </CountryContext.Provider>
  );
}; 